import { render, staticRenderFns } from "./DiscernmentIdCard.vue?vue&type=template&id=371c33ca&scoped=true"
import script from "./DiscernmentIdCard.vue?vue&type=script&lang=js"
export * from "./DiscernmentIdCard.vue?vue&type=script&lang=js"
import style0 from "./DiscernmentIdCard.vue?vue&type=style&index=0&id=371c33ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371c33ca",
  null
  
)

export default component.exports